import { Injectable } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { CAR_STATUS } from '../app.constants';
import { CarService, Car } from '../member-kanri/car.service';

declare let google: any;


@Injectable()
export class GooglemapService {
    
    private geocoder: any = null;
    directionsRenderer_before: any;
    directionMarker = [];
    carMarker = [];
    carInfoWindow = [];

    carList: Car[];

    constructor(
        private mapsAPILoader: MapsAPILoader,
    ) { }


    public getLatLngFromSearch(searchText: string): Promise<any> {
        return this.mapsAPILoader.load().then(() => {
            this.geocoder = new google.maps.Geocoder();
            return new Promise((resolve, reject) => {
                let request = { address: searchText, region: 'jp' };
                this.geocoder.geocode(request, (results, status) => {
                    if (status == google.maps.GeocoderStatus.OK) {
                        resolve(results[0].geometry.location);
                    } else {
                        reject("※入力場所が地図上で特定できません。");
                    }
                });
            });
        });
    }


    public getLatLngFromAddress(address: string): Promise<any> {
        return this.mapsAPILoader.load().then(() => {
            this.geocoder = new google.maps.Geocoder();
            return new Promise((resolve, reject) => {
                let request = { address: address, region: 'jp' };
                this.geocoder.geocode(request, (results, status) => {
                    
                    if (status == google.maps.GeocoderStatus.OK && results.length == 1 
                        && (results[0].geometry.location_type == "ROOFTOP" || results[0].geometry.location_type == "GEOMETRIC_CENTER")) {
                        resolve(results[0].geometry.location);
                    } else {
                        reject("※該当住所の地図上座標が取得できません。");
                    }
                });
            });
        });
    }


    public getAddressFromLatLng(lat: number, lng: number): Promise<any> {
        return this.mapsAPILoader.load().then(() => {
            this.geocoder = new google.maps.Geocoder();
            return new Promise((resolve, reject) => {
                let request = { latLng: new google.maps.LatLng(lat, lng) };
                let addr = "";
                let locationInfo = new LocationInfo("","","","","");
                this.geocoder.geocode(request, (results, status) => {
                    if (status == google.maps.GeocoderStatus.OK) {
                        addr = results[0].formatted_address;
                        var components = results[0].address_components;

                        addr = addr.replace('日本、〒','').replace(' ','');

                        for (var i=0; i<components.length; i++) {
                            if (components[i].types[0] == "postal_code") {
                                addr = addr.replace(components[i].long_name,'');
                                locationInfo.zipcode = components[i].long_name;
                            }
                            if (components[i].types[0] == "administrative_area_level_1") {
                                addr = addr.replace(components[i].long_name,'');
                                locationInfo.todohuken = components[i].long_name;
                            }
                        }
                        locationInfo.address = addr;
                        resolve(locationInfo);
                    } else {
                        reject("※該当場所の住所が取得できませんでした。");
                    }
                });
            });
        });
    }


    public getDistanceAndDuration(o_lat:number, o_lng:number, d_lat:number, d_lng:number): Promise<any> {
        return this.mapsAPILoader.load().then(() => {
            var directionsService = new google.maps.DirectionsService();
            return new Promise((resolve, reject) => {
                let request = { origin: new google.maps.LatLng(o_lat, o_lng), destination: new google.maps.LatLng(d_lat, d_lng), travelMode: google.maps.DirectionsTravelMode.DRIVING, unitSystem: google.maps.DirectionsUnitSystem.METRIC };
                directionsService.route(request, (results, status) => {
                    if (status == google.maps.DirectionsStatus.OK) {
                        var dist = results.routes[0].legs[0].distance.text;
                        var dura = results.routes[0].legs[0].duration.text;
                        resolve("■距離：" + dist + "  ■所要時間：" + dura);
                    } else {
                        reject("※該当場所の住所が取得できませんでした。");
                    }
                });
            });
        });
    }

    public drawDirection(map:any, origin:any, destination:any): Promise<any> {
        return this.mapsAPILoader.load().then(() => {

            if(this.directionsRenderer_before) {
                this.directionsRenderer_before.setMap(null);
            }

            var request = {
                origin: origin,
                destination: destination,
                travelMode: google.maps.DirectionsTravelMode.DRIVING,
                unitSystem: google.maps.DirectionsUnitSystem.METRIC
            };

            var rendererOptions = {
                map: map,
                draggable: false,
                preserveViewport: false,
                suppressMarkers: true,
                suppressInfoWindows: true
            };

            this.createDirectionsMarker(map, origin, destination);

            return new Promise((resolve, reject) => {
                if (origin.lat && origin.lat != 0 && destination.lat && destination.lat != 0) {
                    var directionsService = new google.maps.DirectionsService();
                    var directionsRenderer = new google.maps.DirectionsRenderer(rendererOptions);
                    this.directionsRenderer_before = directionsRenderer;
                    directionsService.route(request, (results, status) => {
                        if (status == google.maps.DirectionsStatus.OK) {
                            
                            var dist = results.routes[0].legs[0].distance.text;
                            var dura = results.routes[0].legs[0].duration.text;
                            directionsRenderer.setDirections(results);
                            resolve("■距離：" + dist + "　■所要時間：" + dura);
                        } else {
                            reject("※経路情報取得に失敗しました。");
                        }
                    });
                }
                else if((!origin.lat || origin.lat == 0) && (!destination.lat || destination.lat == 0)) {
                    resolve("※入力住所から地図上座標が取得できませんでした。");
                }
                else {
                    map.setCenter(origin.lat && origin.lat != 0 ? origin : destination);
                    resolve("");
                }
            });
        });
    }

    createDirectionsMarker(map, origin, destination) {
        for (var i=0; i<this.directionMarker.length; i++) {
            this.directionMarker[i].setMap(null);
        }
        this.directionMarker = [];
        if (origin.lat && origin.lat != 0) {
            this.directionMarker.push(new google.maps.Marker({
                map: map,
                position: origin,
                label: '積み',
                opacity: 0.8  //塗り潰し透過率
            }));
        }
        if (destination.lat && destination.lat != 0) {
            this.directionMarker.push(new google.maps.Marker({
                map: map,
                position: destination,
                label: '卸し',
                opacity: 0.8  //塗り潰し透過率
            }));
        }
    }


    clearCarMarker() {
        for (var i=0; i<this.carMarker.length; i++) {
            this.carMarker[i].setMap(null);
        }
        for (var i=0; i<this.carInfoWindow.length; i++) {
            this.carInfoWindow[i] = null;
        }
        this.carMarker = [];
        this.carInfoWindow = [];
    }


    createCarMarker(map, carList, isOpenInfoWindow:boolean) {
        //現在表示中の車両マーカを消す
        this.clearCarMarker();

        this.mapsAPILoader.load().then(() => {
            for (var i=0; i<carList.length; i++) {
                this.carMarker[i] = new google.maps.Marker({
                    position: { lat:+carList[i].lat, lng:+carList[i].lng },
                    icon: '/assets/images/'+(carList[i].status==CAR_STATUS.IN_TRANS?'Truck-icon_48px.png':'Truck-icon_empty_48px.png'),
                    draggable: false,
                    map: map
                });
    
                let infoText = "■車両No：" + carList[i].car_no 
                            + "<br>■車両タイプ：" + carList[i].car_type_name
                            + "<br>■積載可能重量：" + carList[i].weight + "kg"
                            + "<br>■荷台サイズ：" + carList[i].depth + "✖" + carList[i].width + "✖" + carList[i].height + "cm";
                if (carList[i].driver_id) {
                    infoText = infoText + "<br>■ドライバー：" + carList[i].driver_name
                                        + "<br>■携帯：" + carList[i].driver_mobile
                }            
                
                this.carInfoWindow[i] = new google.maps.InfoWindow({
                    content: infoText,
                    pixelOffset: new google.maps.Size(0, 20),   //表示位置を下へ20px移動
                    noSuppress: true
                });
    
                this.markerInfo(map, i, carList[i].id);
            }

            if (isOpenInfoWindow) {
                this.openInfoWindow(map, 0);
            }
        });
    }

    private markerInfo(map, i:number, carId:number) {
        google.maps.event.addListener(this.carMarker[i], 'click', (() => {
            this.carInfoWindow[i].open(map, this.carMarker[i]);
            //if (this.status != AppConstants.STATUS__MATCH_CAR) {
            //    this.selectCar.emit(this.carList.find(({id})=>id===carId));
            //}
        }));
    }

    public openInfoWindow(map, i: number) {
        this.carInfoWindow[i].open(map, this.carMarker[i]);
    }
}


export class LocationInfo {
    lat: number;
    lng: number;
    zipcode: string;
    todohuken: string;
    address: string;

    constructor(lat, lng, zipcode, todohuken, address) {
        this.lat = lat;
        this.lng = lng;
        this.zipcode = zipcode;
        this.todohuken = todohuken;
        this.address = address;
    }
}


export class MarkerInfo {
    lat: number;
    lng: number;
    label: string;
    iconUrl: string;

    constructor(lat, lng, label, iconUrl) {
        this.lat = lat;
        this.lng = lng;
        this.label = label;
        this.iconUrl = iconUrl;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/googlemap.service.ts